import { Box } from '@mui/material'
import React from 'react'
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { Link as RouterLink } from "react-router-dom";
import { ListItemIcon } from "@mui/material";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import { collection, query, getDocs } from "firebase/firestore";
import { db } from "../../firebase-config";

function ListItemLink(props) {
    const { primary, to } = props;

    const renderLink = React.useMemo(
        () =>
            React.forwardRef(function Link(itemProps, ref) {
                return <RouterLink to={to} ref={ref} {...itemProps} role={undefined} />;
            }),
        [to]
    );

    return (
        <Card>
            <CardContent>
                <li>
                    <ListItemButton component={renderLink}>
                        <ListItemText primary={primary} />
                        <ListItemIcon>
                            <ArrowForwardRoundedIcon />
                        </ListItemIcon>
                    </ListItemButton>
                </li>
            </CardContent>
        </Card>
    );
}

export default function IndustriesList({ sectorId }) {
    const [industries, setIndustries] = React.useState([]);
    const [loading, setLoading] = React.useState(true);

    // Get all the NAICS Sectors
    async function fetchIndustries({ sectorId }) {
        setLoading(true);
        const q = query(
            collection(db, `NAICS-Sectors/${sectorId}/industries`),
        );

        const allDocs = [];
        const querySnapshot = await getDocs(q);

        querySnapshot.forEach((doc) => {
            const data = {
                ...doc.data(),
                "id": doc.id
            }
            allDocs.push(data);
        });

        setIndustries(allDocs)
        setLoading(false)
    }

    React.useEffect(() => {
        fetchIndustries({ sectorId });
    }, [sectorId]);

    return loading ? <Box>
        <Typography variant='h5' align="center">Loading...</Typography>
    </Box> : (
        <Box>
            <List dense={false}>
                <Grid container spacing={2}>
                    {industries.map((industry, index) => {
                        return (
                            <Grid item xs={12} md={6} key={index}>
                                <ListItemLink primary={`${industry.name} in Kenya`} to={`${industry.id}/overview`} />
                            </Grid>
                        );
                    })}
                </Grid>
            </List>
        </Box>
    )
}
